<template>
    <div class="container">
        <div class="card-item">
            <div class="card-title">
                <p v-for="(item,index) in tabList" :key="index" @click="tabToggle(index)" :class="{active:index === sel}">{{item}}</p>
            </div>
            <div class="card-content">
                <div style="background:#fff;text-align: right;margin: 15px 0">
                    <el-button type="primary" size="small" v-if="sel == 0">提交审核</el-button>
                    <el-button type="primary" size="small"><i class="el-icon-plus" style="margin: 0 5px"></i>新增中介服务事项</el-button>
                </div>
                <div v-show="sel == 0">
                    <el-table
                            border
                            :data="dataTaxList"
                            @selection-change="handleSelectionChange"
                            :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
                        <el-table-column
                                type="selection"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="date"
                                type="index"
                                label="序号"
                                align="center"
                                width="60px">
                            <template scope="scope">
                                <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                label="状态"
                                align="center"
                                width="205px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="中介服务事项编号"
                                width="210px">
                            <template scope="scope">
                                <p class="btn-operation">
                                    <span v-if="scope.row.statusNum == -1"><i class="el-icon-upload"></i>上传文件</span>
                                    <span v-else>查看</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="中介服务事项名称"
                                width="210px">
                            <template scope="scope">
                                <p class="btn-operation">
                                    <span v-if="scope.row.statusNum == -1"><i class="el-icon-upload"></i>上传文件</span>
                                    <span v-else>查看</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="市住建局"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="提交时间"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="审核时间"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="数据来源"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="dataStatus"
                                align="center"
                                label="数据状态"
                                width="160px">
                            <template scope="scope">
                                <p class="data-status">
                                    <i v-if="scope.row.statusNum == 1" class="effective"></i>
                                    <i v-if="scope.row.statusNum == -1" class="toBeEffective"></i>
                                    <i v-if="scope.row.statusNum == 0" class="toVoid"></i>
                                    <span v-if="scope.row.statusNum == 1">有效</span>
                                    <span v-if="scope.row.statusNum == -1">待生效</span>
                                    <span v-if="scope.row.statusNum == 0">已作废</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                label="登记时间"
                                align="center"
                                width="185px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                label="作废日期"
                                align="center"
                                width="185px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                label="操作"
                                align="center"
                                width="150px">
                            <template scope="scope">
                                <p class="btn-operation" v-if="scope.row.statusNum == -1"><span>修改</span><span>删除</span></p>
                                <p class="btn-operation" v-else-if="scope.row.statusNum == 1"><span>作废</span></p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-show="sel == 1">
                    <el-table
                            border
                            :data="dataTaxList"
                            :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
                        <el-table-column
                                fixed
                                prop="date"
                                type="index"
                                label="序号"
                                align="center"
                                width="60px">
                            <template scope="scope">
                                <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                label="中介服务事项编号"
                                align="center"
                                width="205px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="中介服务事项名称"
                                width="210px">
                            <template scope="scope">
                                <p class="btn-operation">
                                    <span v-if="scope.row.statusNum == -1"><i class="el-icon-upload"></i>上传文件</span>
                                    <span v-else>查看</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="所属部门"
                                width="210px">
                            <template scope="scope">
                                <p class="btn-operation">
                                    <span v-if="scope.row.statusNum == -1"><i class="el-icon-upload"></i>上传文件</span>
                                    <span v-else>查看</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="数据来源"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="数据状态"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="登记日期"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                label="作废日期"
                                min-width="160px">
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                label="操作"
                                align="center"
                                width="150px">
                            <template scope="scope">
                                <p class="btn-operation" v-if="scope.row.statusNum == -1"><span>修改</span><span>删除</span></p>
                                <p class="btn-operation" v-else-if="scope.row.statusNum == 1"><span>作废</span></p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "intermediary-services-form",
        data() {
            return {
                time:'',
                tabList: ['涉批中介服务事项', '代理机构中介服务事项'],
                sel: 0,
                dataTaxList:[{dataStatus:'有效',statusNum:1},{dataStatus:'待生效',statusNum:-1,updateTime:'2021-06-10'},{dataStatus:'已作废',statusNum:0}],
                dataSocialList:[{dataStatus:'有效',statusNum:1},{dataStatus:'待生效',statusNum:-1,updateTime:'2021-06-10'},{dataStatus:'已作废',statusNum:0}],
                currentPage:1,
                pageSize:10,
                multipleSelection: []
            }
        },
        methods: {
            tabToggle (index) {
                this.sel = index;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }

        }
    }
</script>

<style lang="scss" scoped>
    .container{
        .card-item{
            .card-title{
                cursor: pointer;
                display: flex;
                align-items: center;
                p{
                    font-size: 16px;
                    margin: 0 32px;
                }
                .active{
                    color: #1890FF;
                    border-bottom: 2px solid #1890FF;
                    margin-bottom: -2px;
                }
            }
        }
        .data-status{
            display: flex;
            align-items: center;
            justify-content: center;
            i{
                width: 6px;
                height: 6px;
                border-radius: 50%;
                margin: 0 8px;
            }
            i.effective{
                background: #52C41A;
            }
            i.toBeEffective{
                background: yellow;
            }
            i.toVoid{
                background: #F5222D;
            }
            span{
                width: 60px;
                text-align: left;
            }
        }
        .btn-operation{
            font-size: 14px;
            color: #1890FF;
            display: flex;
            justify-content: center;
            span{
                margin: 0 10px;
                cursor: pointer;
            }
        }
    }
    @media screen and (max-width:1440px){
        /deep/.el-date-editor--daterange{
            width: 260px;
        }
    }
</style>